import { SVG, SVGProps } from './svg'

export function IconDrawingSettingAutosaveOn(props: SVGProps) {
  return (
    <SVG {...props} viewBox="0 0 32 32">
      <path
        fillRule="evenodd"
        d="M19.854 15.854a.5.5 0 0 0-.708-.708L15 19.293l-2.146-2.147a.5.5 0 0 0-.708.708l2.5 2.5a.5.5 0 0 0 .708 0l4.5-4.5z M16 8a7.001 7.001 0 0 0-6.954 6.194A5.502 5.502 0 0 0 10.5 25h10a6.5 6.5 0 0 0 1.96-12.699A7.001 7.001 0 0 0 16 8zm0 1a6 6 0 0 0-6 6v.027A4.5 4.5 0 0 0 10.5 24h10a5.5 5.5 0 0 0 1.203-10.868A6.003 6.003 0 0 0 16 9z"
      />
    </SVG>
  )
}
